import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guest-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterGuestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
